import type { ApiAcceptedLanguage } from '@izimi/api';

export const getExternalLinks = ({ lang }: { lang: ApiAcceptedLanguage }) => {
  const urls: Record<ApiAcceptedLanguage, { privacyPolicy: string }> = {
    fr: {
      privacyPolicy: 'https://www.fednot.be/politique-de-protection-des-donnees/',
    },
    nl: {
      privacyPolicy: 'https://www.fednot.be/nl/privacybeleid/',
    },
    en: {
      privacyPolicy: 'https://www.fednot.be/politique-de-protection-des-donnees/',
    },
    de: {
      privacyPolicy: 'https://www.fednot.be/politique-de-protection-des-donnees/',
    },
  };

  return urls[lang] ?? urls.fr;
};
